export function formatPeriod(periodString: any, language: string, trans: any) {
    if (typeof periodString !== 'string') {
        return periodString;
    }

    const dayPattern = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
    const monthPattern = /^[0-9]{2}-[0-9]{4}$/;
    const quarterPattern = /^Q[0-9]\s[0-9]{4}$/;

    if (dayPattern.test(periodString)) {
        // console.log("PATTERN 1 matched");
        const date = new Date(Date.UTC(parseInt(periodString.substring(6, 10)), parseInt(periodString.substring(3, 5)), parseInt(periodString.substring(0, 2)), 0, 0, 0));
        return date.toLocaleDateString(language + "-" + language.toUpperCase(), { day: 'numeric', month: 'numeric', year: 'numeric' });
    } else if (monthPattern.test(periodString)) {
        // console.log("PATTERN 1 matched");
        const date = new Date(Date.UTC(parseInt(periodString.substring(3, 7)), parseInt(periodString.substring(0, 2)), 0, 0, 0, 0));
        return date.toLocaleDateString(language + "-" + language.toUpperCase(), { month: 'short', year: 'numeric' });
    } else if (quarterPattern.test(periodString)) {
        // console.log("PATTERN 2 matched");
        return periodString.substring(1, 2) + trans.thTrim[language] + " " + periodString.substring(3, 7);
    } else {
        // console.log("NO MATCH");
        return periodString;
    }
}

export function periodDateFormat(period: any) {
    const simpleDatePattern = /^([0-9]{2}-)?[0-9]{4}$/;
    const yearPattern = /^([0-9]{4})$/;
    return [simpleDatePattern.test(period), yearPattern.test(period)];
}

export function getDateFromString(dateString: string) {
    const pattern = /^(?:([0-9]{2})-)?([0-9]{4})$/;
    const matches = dateString.match(pattern);
    if (matches) {
        const month = matches[1];
        const year = matches[2];
        return new Date(Date.UTC(parseInt(year), parseInt(month ? month : "0"), 0, 0, 0, 0));
    }

    return new Date();
}

export function getWindowParent(): undefined | Window {
    let parent: undefined | Window;
    try {
        if (window.parent !== undefined && window.self !== window.top) {
            parent = window.parent;
        } else {
            parent = undefined;
        }
    } catch (e) {
        parent = undefined;
    }

    return parent;
}

export function formatValue(value: number | string, fractionDigits: number, lang: string, translations: any): string {
    return (typeof value === 'number' ? new Intl.NumberFormat(lang === "de" ? "de-DE" : "it-IT", {
        minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits
    }).format(value) : formatPeriod(value, lang, translations));
}